import {computed,shallowReactive} from 'vue'
import {defineStore} from 'pinia'
interface PageSidebar {fallback?:boolean;label:()=>string;expanded:()=>boolean;toggle:(trigger?:HTMLElement)=>void;close:()=>void}
/** Page-owned navigation only; never persists navigation state across viewers/routes. */
export const usePageNavigationStore=defineStore('pageNavigation',()=>{
 const sidebars=shallowReactive(new Map<symbol,PageSidebar>())
 const current=computed(()=>{const all=[...sidebars.values()],pages=all.filter(s=>!s.fallback),rows=pages.length?pages:all;return rows[rows.length-1]})
 function register(sidebar:PageSidebar){const id=Symbol();sidebars.set(id,sidebar);return ()=>sidebars.delete(id)}
 return {current,register}
})
